import { render, staticRenderFns } from "./ConfigRadio.vue?vue&type=template&id=5bede77f&scoped=true&"
import script from "./ConfigRadio.vue?vue&type=script&lang=ts&"
export * from "./ConfigRadio.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigRadio.vue?vue&type=style&index=0&id=5bede77f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bede77f",
  null
  
)

export default component.exports